export default __webpack_public_path__ + "static/media/WebinarMain.bceadcda.jpg";